module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "ym-table table-hover"
  }, [_vm._t("thead"), _vm._v(" "), _vm._t("tbody")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6c651664!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmTable.vue
// module id = 598
// module chunks = 2